import { getTeam } from "src/api/Admin";
import { useAdTeamStore } from "src/stores/AdTeamStore";


export const LoadTeam = async () => {
  const setField = useAdTeamStore.getState().setField; // ✅ 훅이 아니라 직접 store 접근

  const response = await getTeam();
  setField('tableData', response.data);
};